import { createActions } from "redux-actions"

const prefix = "SIGN_UP"

const actionMap = {}

const actionTypes = ["NEXT_STEP", "PREVIOUS_STEP", "SET_FORM_STATE", "CLEAR"]

export default createActions(actionMap, ...actionTypes, { prefix })
